import TrpcLibrary from 'digicel-kaizen-library/lib/tripica-library';
import { connect } from 'react-redux';
import { fetchDetailedUsages } from '../../../actions/usage';
import { currentSubscriptionNextRenewalDateSelector } from '../../../modules/Dashboard';
import { isLoadingSelector } from '../../../modules/LoadingStatus';
import UsageDetail from './UsageDetail';

const mapStateToProps = state => ({
  usages: state.usage.detailedUsages.length ? TrpcLibrary.getExtraUsage(state.usage.detailedUsages) : [],
  isFetching: isLoadingSelector(state, 'fetchDetailedUsages'),
  nextRenewalDate: currentSubscriptionNextRenewalDateSelector(state),
});

const mapDispatchToProps = {
  fetchDetailedUsages,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsageDetail);
